/** Match public permission data in production and legacy development errors. */
export function isConvexPermissionDenied(error) {
  let current = error;
  const seen = new Set();

  while (current && !seen.has(current)) {
    seen.add(current);
    if (current.data === "Forbidden") {
      return true;
    }
    const message = current.message ?? String(current);
    if (message.includes("Forbidden")) {
      return true;
    }
    current = current.cause;
  }

  return false;
}

export const PERMISSION_DENIED_MESSAGE =
  "You don't have permission to view this.";
